import { LOGOUT } from 'reducers/action-constants';

export const logout = () => (dispatch: any) => dispatch({ type: LOGOUT });
